module.exports = __webpack_public_path__ + "img/map_Z2.1.D.04.47e26684.svg";